import React from 'react'
import { Box, Flex, styled } from '@chilipiper/design-system'

export const TypingAnimation = () => (
  <Flex
    color='white'
    bg='neutral-dark-40'
    p={4}
    fontWeight={500}
    h={9}
    borderRadius={8}
    alignItems='center'
  >
    <StyledDot />
    <StyledDot mx={1} />
    <StyledDot />
  </Flex>
)

const StyledDot = styled(Box)`
  height: 0.35rem;
  width: 0.35rem;
  border-radius: 50%;
  background: white;
  animation: ease-in-out 1.5s jump infinite;

  :nth-of-type(2) {
    animation-delay: 0.15s;
  }

  :nth-of-type(3) {
    animation-delay: 0.3s;
  }

  @keyframes jump {
    0%, 40%, 100% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(-6px);
    }
`
